import { render, staticRenderFns } from "./ViewButton.vue?vue&type=template&id=6beeda04&scoped=true&"
import script from "./ViewButton.vue?vue&type=script&lang=js&"
export * from "./ViewButton.vue?vue&type=script&lang=js&"
import style0 from "./ViewButton.vue?vue&type=style&index=0&id=6beeda04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6beeda04",
  null
  
)

export default component.exports